// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

export const version = '4.16.2';

export const returnBindingKey = '$return';
